import { Card, Table, TableCell, TableContainer, TableHead, TableRow, TableBody, Grid, TextField, Button } from '@mui/material'
import React from 'react'
import Paper from '@mui/material/Paper';
function Notes() {
    return (
        <div>
            <Grid container alignItems="center" sx={{ p: 1 }} item xs={8}>
                <TextField
                    sx={{ width: '80%' }}
                    label="Add Note"
                    size="small"

                />
                <Button type="submit" variant="contained" color="primary" sx={{ ml: 1 }}>
                    Submit
                </Button>
            </Grid>
            <Card sx={{ mt: 5 }} variant="outlined">
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>NO</TableCell>
                                <TableCell>Notes</TableCell>
                                <TableCell>Created Date</TableCell>

                                <TableCell> </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            <TableRow

                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, marginTop: 5 }}
                            >
                                <TableCell>1</TableCell>
                                <TableCell>test
                                </TableCell>
                                <TableCell>22/3/2022</TableCell>

                                <TableCell>delete</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </Card>
        </div>
    )
}

export default Notes
